<div class="modal-content">
    <h1 mat-dialog-title>Your session is about to expire.</h1>
    <div mat-dialog-content class="dialog-content">
        <span class="dialog-content-error">
            Your session will expire in <strong>{{ CountDownTime }}</strong> seconds.
        </span>
        <p>
            Click "Keep Working" if you want to continue and stay logged in.
        </p>
    </div>
    <div class="action-button-container" mat-dialog-actions align="end">
        <button id="session-to-dialog-logout" mat-flat-button color="accent" (click)="OnClickRedirectToLogin()">Log Out</button>
        <button id="session-to-dialog-keep" mat-flat-button color="primary" (click)="OnClickKeepWorking()">Keep Working</button>
    </div>
</div>
